/* import __COLOCATED_TEMPLATE__ from './unassign-unsnoozed-setting.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Args {
  unassignUnsnoozedAtCapacityEnabled: boolean;
  unassignUnsnoozedAtCapacityUpdate(value: boolean): void;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class UnassignUnsnoozedSetting extends Component<Signature> {
  @action
  toggleUnassignUnsnoozedAtCapacity() {
    let newValue = !this.args.unassignUnsnoozedAtCapacityEnabled;
    this.args.unassignUnsnoozedAtCapacityUpdate(newValue);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox::WorkloadManagement::UnassignUnsnoozedSetting': typeof UnassignUnsnoozedSetting;
    'inbox/workload-management/unassign-unsnoozed-setting': typeof UnassignUnsnoozedSetting;
  }
}
